export default __webpack_public_path__ + "static/media/youtube.1b9d00c4.svg";